import React from "react";
import "./Footer.css";
import logo from "../../assets/images/footer-logo.png";
import sigmaLogo from "../../assets/images/default-footer-logo.png";
import { Row, Col } from "antd";
import { useTranslation } from "react-i18next";
import { miliphoreCounties } from "../../constants/app-constant";

export default () => {
  const { t } = useTranslation();
  const _country = localStorage.getItem("_country");
  return (
    <Row className="footer">
      <Col md={4} sm={2} className="fooetr-logo">
        <img
          src={
            _country && miliphoreCounties.indexOf(_country) !== -1
              ? sigmaLogo
              : logo
          }
          alt="footer logo"
        />
      </Col>
      <Col md={20} sm={22} className="footer-text">
        <span className="bold">
          {_country && miliphoreCounties.indexOf(_country) !== -1
            ? t("footer.sigmaText")
            : t("footer.merckText")}
        </span>
        <span className="no-bold">{t("footer.merckText2")}</span>
        {/* <a href="">{t("footer.merckTermsText")}</a>| */}
        {/* <a href="">{t("footer.privacyText")}</a> */}
      </Col>
    </Row>
  );
};
